<template>
  <BreadCrumb PageTitle="Nouveau Bon de retour" />
  <AddReturn />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import AddReturn from "@/components/Notes/Return/Zone/AddReturn.vue";

export default defineComponent({
  name: "AddReturnPage",
  components: {
    BreadCrumb,
    AddReturn,
  },
});
</script>